import "./premiummodal.css"
import React from "react";

const PremiumModal = ({ isOpen, onClose, onSubscribe }) => {
    if (!isOpen) return null;

    return (
        <div className="premium-modal-overlay">
            <div className="premium-modal">
                <div className="premium-modal-header">
                    <h2>Réservé aux utilisateurs premium</h2>
                    <button className="premium-modal-close" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="premium-modal-content">
                    <p>L'enregistrement et le classement des décisions sont réservés aux utilisateurs premium.</p>
                </div>
                <div className="premium-modal-footer">
                    <button className="premium-modal-cancel" onClick={onClose}>
                        Annuler
                    </button>
                    <button className="premium-modal-subscribe" onClick={onSubscribe}>
                        Souscrire
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PremiumModal;